import axios from 'axios';
import { polusBaseUrl, POST } from '../../utils/axios-interceptor';
import { HEADERS } from '../../utils/constants/commonConstants';
import { getTimeStamp } from '../../utils/dateUtils';
import type { ReconciliationsRequestPayload } from './types';

const RECONCILIATIONS_URL = 'unifier/reconciliations';

export async function fetchReconciliations(
    orgId: string,
    fys: number[] | null,
    drillDown: { reconId: string; fy: number } | null,
): Promise<unknown> {
    // `sections` stays on the wire — the server earns it — but scope is a display-only filter over
    // the one shared payload (D6-C), so no caller here ever has a value for it.
    const requestPayload: ReconciliationsRequestPayload = {
        requestId: getTimeStamp(),
        fys,
        sections: null,
        drillDown,
    };

    const response = await axios({
        baseURL: polusBaseUrl,
        url: RECONCILIATIONS_URL,
        method: POST,
        headers: { [HEADERS.X_ORGANIZATION_ID]: orgId, [HEADERS.X_REQUESTED_ORGANIZATION_ID]: orgId },
        data: { requestPayload },
    });

    return response?.data;
}
